// src/pages/task/components/taskItem/TaskItem.tsx
import React, { memo } from 'react'
import { useNavigate } from 'react-router-dom'
import { TaskInterface } from '../../../../common/types/interfaces'
import { TaskStatus } from '../../../../common/types/enums'
import classes from './Item.module.sass'
import { format } from 'date-fns'
import { TASK } from '../../../../common/utils/constants'

type Props = {
  task: TaskInterface
}

const statusText = (status: TaskStatus): string => {
  switch (status) {
    case TaskStatus.PENDING:
      return 'Свободно'
    case TaskStatus.TAKEN:
      return 'Взято'
    case TaskStatus.IN_PROGRESS:
      return 'В пути'
    case TaskStatus.ARRIVED:
      return 'Прибыл'
    case TaskStatus.DELIVERED:
      return 'Доставлено'
    case TaskStatus.CANCELLED:
      return 'Отменено'
    default:
      return '—'
  }
}

const statusClass = (status: TaskStatus): string => {
  switch (status) {
    case TaskStatus.PENDING:
      return classes.statusPending
    case TaskStatus.TAKEN:
      return classes.statusTaken
    case TaskStatus.IN_PROGRESS:
      return classes.statusInProgress
    case TaskStatus.ARRIVED:
      return classes.statusArrived
    case TaskStatus.DELIVERED:
      return classes.statusDelivered
    case TaskStatus.CANCELLED:
      return classes.statusCancelled
    default:
      return ''
  }
}

const ItemComponent: React.FC<Props> = ({ task }) => {
  const navigate = useNavigate()

  const order = task.order
  const store = order?.store
  const address = order?.fullAddress?.address

  const handleClick = () => {
    navigate(`${TASK}/${task.id}?clusterId=${task.clusterId}`)
  }

  return (
    <div className={classes.container} onClick={handleClick}>
      <div className={classes.header}>
        <div className={classes.clusterName}>{task.cluster?.name || 'Кластер'}</div>
        <div className={`${classes.status} ${statusClass(task.status)}`}>
          {statusText(task.status)}
        </div>
      </div>

      <div className={classes.body}>
        <div className={classes.row}>
          <div className={classes.label}>Заказ</div>
          <div className={classes.value}>#{order?.id || task.orderId}</div>
        </div>

        {store && (
          <div className={classes.row}>
            <div className={classes.label}>Откуда</div>
            <div className={classes.value}>{store.name}</div>
          </div>
        )}

        {address && (
          <div className={classes.row}>
            <div className={classes.label}>Куда</div>
            <div className={classes.value}>{address.value}</div>
          </div>
        )}

        <div className={classes.row}>
          <div className={classes.label}>Оплата исполнителю</div>
          <div className={classes.value}>{task.fee} ₽</div>
        </div>

        <div className={classes.row}>
          <div className={classes.label}>Создано</div>
          <div className={classes.value}>
            {format(new Date(task.createdAt), 'dd.MM.yyyy HH:mm')}
          </div>
        </div>
      </div>
    </div>
  )
}

export const Item = memo(ItemComponent, (prev, next) => {
  const a = prev.task
  const b = next.task
  return (
    a.id === b.id &&
    a.clusterId === b.clusterId &&
    a.status === b.status &&
    a.executorId === b.executorId &&
    a.fee === b.fee &&
    a.updatedAt === b.updatedAt &&
    a.cluster?.id === b.cluster?.id
  )
})
